{
  "screen": {
    "sectionHeading": "Death",
    "open": "Record a death",
    "openCorrection": "Correct the death record",
    "heading": "Record a death",
    "correctionHeading": "Correct the death record",
    "explanation": "Records that the patient has died. You are named as the physician who established the death, and the record is signed in your name. The stay continues and the bed is kept until the patient is discharged.",
    "correctionExplanation": "The correction becomes a new version. The earlier one stays in the record. The physician who established the death is still named.",
    "requiredHint": "Fields without a note are required.",
    "optional": "optional",
    "final": "A death record cannot be removed. If it is wrong, correct it — or withdraw it if it is on the wrong patient.",
    "save": "Record and sign",
    "saveCorrection": "Save the correction and sign",
    "saving": "Saving …",
    "cancel": "Cancel",
    "close": "Close",
    "saved": "The death is recorded and signed.",
    "savedCorrection": "The correction is saved and signed.",
    "discardQuestion": "Close the form? Nothing is recorded.",
    "discardConfirm": "Close without saving",
    "discardCancel": "Keep filling in",
    "physicianOnly": "Only a physician can record a death, because whoever records it is named as having established it."
  },
  "field": {
    "diedAt": "Time of death",
    "estimated": "The time is estimated — the patient was found dead",
    "pronouncedAt": "Death established",
    "police": "Reported to the police",
    "note": "Circumstances",
    "withdraw": "The record is on the wrong patient or is wrong — withdraw it"
  },
  "fieldHint": {
    "diedAt": "YYYY-MM-DD HH:MM, 24-hour clock. Change it if the death happened earlier than now.",
    "pronouncedAt": "When you established the death, YYYY-MM-DD HH:MM. Not before the time of death.",
    "police": "The police decide on a forensic examination. Choose an answer — none is preselected.",
    "note": "How and where the patient was found, who was present. Do not write the cause of death here — it belongs in the death certificate."
  },
  "police": {
    "notified": "Yes, reported to the police",
    "not-notified": "No, not reported",
    "not-assessed": "Not assessed yet"
  },
  "banner": {
    "died": "Died {diedAt}",
    "diedEstimated": "Died around {diedAt} (estimated time)",
    "pronounced": "Established {pronouncedAt} by {name}",
    "police": "Police report: {answer}"
  },
  "refusal": {
    "timeMissing": "Fill in the field “{field}”. Nothing was recorded.",
    "timeMalformed": "“{field}” does not read as a time. Write it as YYYY-MM-DD HH:MM, for example 2026-10-15 08:00. Nothing was recorded.",
    "timeInFuture": "“{field}” is in the future. Nothing was recorded.",
    "pronouncedBeforeDeath": "The death cannot have been established before it happened. Check the two times. Nothing was recorded.",
    "policeMissing": "Choose whether the death has been reported to the police. Nothing was recorded.",
    "fieldTooLong": "The circumstances are too long. Shorten them to at most {max} characters. Nothing was recorded.",
    "alreadyRecorded": "A death is already recorded for this patient. The overview is updated — correct that one instead. Nothing was recorded.",
    "noChange": "The correction changes nothing. Nothing was saved.",
    "stale": "Somebody else changed the record while the form was open. The overview is updated — check it and try again. Nothing was saved.",
    "retracted": "The record is already withdrawn and cannot be corrected.",
    "notFound": "The record is not in the journal. Open the patient overview again.",
    "patientNotFound": "The patient is not in the record. Nothing was recorded.",
    "roleMayNotEstablishDeath": "Only a physician can record a death. Nothing was recorded.",
    "unknown": "Nothing was recorded. Try again.",
    "unavailable": "No contact with the server. It is not certain whether the record was saved — open the patient overview again and check before trying again."
  }
}
